
import { supabase } from '@/integrations/supabase/client';
import { SubscriptionWithRelations, mapSubscriptionFromDb } from '@/services/types/subscriptionTypes';

// Получение подробной информации о подписке с данными связанных таблиц
export const fetchSubscriptionDetails = async (subscriptionId: string) => {
  try {
    console.log(`Загрузка деталей подписки ${subscriptionId}`);
    
    const { data, error } = await supabase
      .from('subscriptions')
      .select(`
        *,
        rentals:rental_id (
          id,
          human_number,
          status,
          courier_id,
          bike_id,
          start_date,
          end_date,
          courier:courier_id (
            id,
            name,
            email,
            phone
          ),
          bikes:bike_id (
            id,
            model,
            serial_number
          )
        ),
        payments (
          id,
          amount,
          payment_date,
          status
        )
      `)
      .eq('id', subscriptionId)
      .single();
      
    if (error) {
      console.error('Ошибка при получении данных подписки:', error);
      return { data: null, error: error.message, success: false };
    }
    
    if (!data) {
      console.error('Подписка не найдена');
      return { data: null, error: 'Подписка не найдена', success: false };
    }
    
    // Преобразуем данные для удобного использования в UI
    const subscription: SubscriptionWithRelations = mapSubscriptionFromDb(data);
    
    // Добавляем велосипед и курьера напрямую из связанных данных
    if (data.rentals) {
      subscription.rentalHumanNumber = data.rentals.human_number;
      
      // Добавляем данные курьера
      if (data.rentals.courier) {
        subscription.courier = data.rentals.courier;
        subscription.courierName = data.rentals.courier.name;
        subscription.courierPhone = data.rentals.courier.phone;
      }
      
      // Добавляем данные велосипеда
      if (data.rentals.bikes) {
        subscription.bike = data.rentals.bikes;
        subscription.bikeName = data.rentals.bikes.model;
      }
    }
    
    console.log('Загружены детали подписки:', subscription);
    return { data: subscription, error: null, success: true };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при загрузке деталей подписки:', err);
    return { data: null, error: err.message, success: false };
  }
};
